import { z } from 'zod'
import { getDuplicatesRefinement } from 'src/util/src/zod'

export const ReferralCodeSchema = z.string().min(1)

export const ReferralCodesSchema = z.array(ReferralCodeSchema)
  .superRefine(getDuplicatesRefinement('ReferralCode', parseReferralCodeUid))

export const ReferralCodeUidSchema = ReferralCodeSchema

export type ReferralCode = z.infer<typeof ReferralCodeSchema>

export type ReferralCodeUid = z.infer<typeof ReferralCodeUidSchema>

export function parseReferralCode(referralCode: ReferralCode): ReferralCode {
  return ReferralCodeSchema.parse(referralCode)
}

export function parseReferralCodes(referralCodes: ReferralCode[]): ReferralCode[] {
  return ReferralCodesSchema.parse(referralCodes)
}

export function parseReferralCodeUid(referralCodeUid: ReferralCodeUid): ReferralCodeUid {
  return ReferralCodeUidSchema.parse(referralCodeUid)
}
